import { Factory } from 'rosie';

Factory.define('Boot').attr('name', 'BOOT');

Factory.define('BootWithDefaults').extend('Boot');



// WEBPACK FOOTER //
// ./factories/location/boot.js